module.exports = __webpack_public_path__ + "media/images/pc/stores/suns/magazine/point01_05_travel-604ba4df29b0ea0ecbac201d2a789a6f.jpg";